module.exports = {"id":"190459","name":"André Hansen","rating":"73","photo":"./data/images/photos/2/190459.png","club":{"name":"Rosenborg BK","logo":"./data/images/clubs/RosenborgBK.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreHansen0.json
// module id = 342
// module chunks = 0